import classNames from 'classnames';
import React, { ReactNode, useState } from 'react';
import styles from './Tabs.module.css';

interface TabsProps {
	children: ReactNode[];
}

interface TabProps {
	title: string;
	children?: ReactNode;
}

export const Tab: React.FC<TabProps> = ({ children }) => {
	return <>{children}</>;
};

export const Tabs: React.FC<TabsProps> = ({ children }) => {
	const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

	const handleTabClick = (index: number) => {
		setSelectedTabIndex(index);
	};

	return (
		<>
			<div className={styles.tabContainer}>
				{React.Children.map(children, (child, i) => {
					if (React.isValidElement(child) && child.type === Tab) {
						return (
							<div
								key={i}
								className={classNames(styles.tab, selectedTabIndex === i && styles.tabSelected)}
								onClick={() => handleTabClick(i)}
							>
								{child.props.title}
							</div>
						);
					}
					return null;
				})}
			</div>
			{/* Render the content of the selected tab */}
			{selectedTabIndex !== null && React.Children.toArray(children)[selectedTabIndex]}
		</>
	);
};
